import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';
import { supabase } from '../../../lib/supabase';

const WelcomeCard = () => {
  const { t } = useTranslation();
  const [data, setData] = useState({ fullName: '', azienda: '', loading: true });

  useEffect(() => {
    const getData = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        const { data: profil } = await supabase
          .from('profili')
          .select('nome, cognome, aziende(nome_azienda)')
          .eq('id', user.id)
          .single();

        if (profil) {
          setData({
            fullName: `${profil.nome} ${profil.cognome}`,
            azienda: profil.aziende?.nome_azienda || 'OrizonDesk',
            loading: false
          });
        }
      }
    };
    getData();
  }, []);

  // Logika za pozdrav na osnovu vremena i prevoda
  const currentHour = new Date().getHours();
  let greetingKey = 'dashboard.welcome_card.morning';
  if (currentHour >= 12 && currentHour < 18) greetingKey = 'dashboard.welcome_card.afternoon';
  if (currentHour >= 18) greetingKey = 'dashboard.welcome_card.evening';

  return (
    <div className="bg-gradient-to-br from-primary to-primary/80 rounded-2xl p-8 text-white shadow-lg">
      <div className="flex justify-between items-start">
        <div>
          <span className="bg-white/20 px-3 py-1 rounded-full text-xs uppercase tracking-widest">
            {data.loading ? t('dashboard.welcome_card.loading') : data.azienda}
          </span>
          <h1 className="text-3xl font-bold mt-4">
            {data.loading 
              ? t('dashboard.welcome_card.loading') 
              : `${t(greetingKey)}, ${data.fullName}!`}
          </h1>
          <p className="mt-2 opacity-80">
            {t('dashboard.welcome_card.subtitle', { azienda: data.azienda })}
          </p>
        </div>
        <Icon name="Sparkles" size={48} className="opacity-20" />
      </div>
    </div>
  );
};

export default WelcomeCard;